export var checkIsInitialFetched = function (_a) {
    var store = _a.store, selectorsCheckInitialFetched = _a.selectorsCheckInitialFetched;
    if (!selectorsCheckInitialFetched || !selectorsCheckInitialFetched.length) {
        return true;
    }
    return selectorsCheckInitialFetched.reduce(function (acc, selector) {
        if (!acc) {
            return acc;
        }
        var fetchedSelectorValue = selector(store.getState());
        return fetchedSelectorValue;
    }, true);
};
